import { Languages } from "../../types";
import { SidebarDescriptions } from "./types";

const DescriptionsEnUs: SidebarDescriptions = {
    FINANCE: {
        TITLE: 'Finance',
        ITEMS: {
            ACCOUNT_PAYABLES: {
                DISPLAY_NAME: 'Account Payables',
                TOOLTIP: '',
            },
            ACCOUNT_RECEIVABLES: {
                DISPLAY_NAME: 'Account Receivables',
                TOOLTIP: '',
            },
            CREATE_EXPENDITURE_RECORD: {
                DISPLAY_NAME: 'Create Expenditure Record',
                TOOLTIP: '',
            },
            EXPENDITURE_RECORDS: {
                DISPLAY_NAME: 'Expenditure Records',
                TOOLTIP: '',
            },
            CREAT_INCOME_RECORD: {
                DISPLAY_NAME: 'Create Income Record',
                TOOLTIP: '',
            },
            INCOME_RECORDS: {
                DISPLAY_NAME: 'Income Records',
                TOOLTIP: '',
            },
        },
    },
    CUSTOMER: {
        TITLE: 'Customers',
        ITEMS: {
            CREATE_SERVICE_CONTRACT: {
                DISPLAY_NAME: 'Create Service Contract',
                TOOLTIP: '',
            },
            CUSTOMERS: {
                DISPLAY_NAME: 'Customers',
                TOOLTIP: '',
            },
            SERVICE_CONTRACT_PAYMENTS: {
                DISPLAY_NAME: "Customer Payments",
                TOOLTIP: '',
            },
            SERVICE_CONTRACTS: {
                DISPLAY_NAME: 'Customer Contracts',
                TOOLTIP: '',
            },
            SERVICE_CONTRACT_DEBITS: {
                DISPLAY_NAME: 'Account Receivables',
                TOOLTIP: '',
            },
        },
    },
    CHAT: {
        TITLE: "ProChat AI",
        ITEMS: {},
    },
    SUPPLIER: {
        TITLE: 'Suppliers',
        ITEMS: {
            PAYABLE_CONTRACTS: {
                DISPLAY_NAME: 'Supplier Contracts',
                TOOLTIP: '',
            },
            PAYABLE_CONTRACT_DEBITS: {
                DISPLAY_NAME: 'Account Payables',
                TOOLTIP: '',
            },
            PAYABLE_CONTRACT_PAYMENTS: {
                DISPLAY_NAME: 'Payable Contract Payments',
                TOOLTIP: '',
            },
            CREATE_PAYABLE_CONTRACT: {
                DISPLAY_NAME: 'Create Payable Contract',
                TOOLTIP: '',
            }
        },
    },
    MAINTENANCE: {
        TITLE: "Maintenance",
        ITEMS: {
            SETTINGS: {
                DISPLAY_NAME: "Settings",
                TOOLTIP: "",
            },
            CASHBOX_CATEGORIES: {
                DISPLAY_NAME: "Cashbox Categories",
                TOOLTIP: "",
            },
            USERS: {
                DISPLAY_NAME: "Users",
                TOOLTIP: "",
            },
            SERVICES: {
                DISPLAY_NAME: 'Services',
                TOOLTIP: '',
            },
            SERVICE_CATEGORIES: {
                DISPLAY_NAME: 'Service Categories',
                TOOLTIP: '',
            },
        },
    },
    QUOTATION: {
        TITLE: "Quotations",
        ITEMS: {
            CREATE_QUOTATION: {
                DISPLAY_NAME: 'Create Quotation',
                TOOLTIP: '',
            },
            QUOTATION_RECORDS: {
                DISPLAY_NAME: 'Quotation Records',
                TOOLTIP: '',
            },
            QUOTATION_TEMPLATES: {
                DISPLAY_NAME: 'Quotation Templates',
                TOOLTIP: '',
            },
        }
    },
    REPORTS: {
        TITLE: "Reports",
        ITEMS: {
            DASHBOARD: {
                DISPLAY_NAME: 'Dashboard',
                TOOLTIP: '',
            },
            CASHBOX_STATEMENT_RECORDS: {
                DISPLAY_NAME: 'Cashbox Statement',
                TOOLTIP: '',
            },
        },
    },
    HOME: {
        TITLE: 'Home',
        ITEMS: {
        },
    },
}

const DescriptionsEsUs: SidebarDescriptions = {
    FINANCE: {
        TITLE: 'Finanzas',
        ITEMS: {
            ACCOUNT_PAYABLES: {
                DISPLAY_NAME: 'Cuentas por Pagar',
                TOOLTIP: '',
            },
            ACCOUNT_RECEIVABLES: {
                DISPLAY_NAME: 'Cuentas por Cobrar',
                TOOLTIP: '',
            },
            CREATE_EXPENDITURE_RECORD: {
                DISPLAY_NAME: 'Registrar Gasto',
                TOOLTIP: '',
            },
            EXPENDITURE_RECORDS: {
                DISPLAY_NAME: 'Registro de Gastos',
                TOOLTIP: '',
            },
            CREAT_INCOME_RECORD: {
                DISPLAY_NAME: 'Registrar Ingreso',
                TOOLTIP: '',
            },
            INCOME_RECORDS: {
                DISPLAY_NAME: 'Registros de Ingresos',
                TOOLTIP: '',
            },
        },
    },
    CUSTOMER: {
        TITLE: 'Clientes',
        ITEMS: {
            CREATE_SERVICE_CONTRACT: {
                DISPLAY_NAME: 'Crear Contrato de Servicios',
                TOOLTIP: '',
            },
            CUSTOMERS: {
                DISPLAY_NAME: 'Clientes',
                TOOLTIP: '',
            },
            SERVICE_CONTRACT_PAYMENTS: {
                DISPLAY_NAME: "Pagos de Clientes",
                TOOLTIP: '',
            },
            SERVICE_CONTRACTS: {
                DISPLAY_NAME: 'Contratos con Clientes',
                TOOLTIP: '',
            },
            SERVICE_CONTRACT_DEBITS: {
                DISPLAY_NAME: 'Cuentas por Cobrar',
                TOOLTIP: '',
            },
        }
    },
    CHAT: {
        TITLE: "ProChat AI",
        ITEMS: {},
    },
    SUPPLIER: {
        TITLE: 'Proveedores',
        ITEMS: {
            CREATE_PAYABLE_CONTRACT: {
                DISPLAY_NAME: 'Crear contracto con Proveedor',
                TOOLTIP: '',
            },
            PAYABLE_CONTRACTS: {
                DISPLAY_NAME: 'Contratos de Proveedores',
                TOOLTIP: '',
            },
            PAYABLE_CONTRACT_DEBITS: {
                DISPLAY_NAME: 'Cuentas por Pagar',
                TOOLTIP: '',
            },
            PAYABLE_CONTRACT_PAYMENTS: {
                DISPLAY_NAME: 'Pagos a Proveedores',
                TOOLTIP: '',
            },
        }
    },
    MAINTENANCE: {
        TITLE: "Mantenimiento",
        ITEMS: {
            SETTINGS: {
                DISPLAY_NAME: "Configuración",
                TOOLTIP: "",
            },
            CASHBOX_CATEGORIES: {
                DISPLAY_NAME: "Categorías de Caja",
                TOOLTIP: "",
            },
            USERS: {
                DISPLAY_NAME: "Usuarios",
                TOOLTIP: "",
            },
            SERVICES: {
                DISPLAY_NAME: 'Servicios',
                TOOLTIP: '',
            },
            SERVICE_CATEGORIES: {
                DISPLAY_NAME: 'Categorías de Servicios',
                TOOLTIP: '',
            },
        },
    },
    QUOTATION: {
        TITLE: "Cotizaciones",
        ITEMS: {
            CREATE_QUOTATION: {
                DISPLAY_NAME: 'Crear Cotización',
                TOOLTIP: '',
            },
            QUOTATION_RECORDS: {
                DISPLAY_NAME: 'Registro de Cotizaciones',
                TOOLTIP: '',
            },
            QUOTATION_TEMPLATES: {
                DISPLAY_NAME: 'Plantillas de Cotización',
                TOOLTIP: '',
            },
        }
    },
    REPORTS: {
        TITLE: "Reportes",
        ITEMS: {
            DASHBOARD: {
                DISPLAY_NAME: 'Tablero de Control',
                TOOLTIP: '',
            },
            CASHBOX_STATEMENT_RECORDS: {
                DISPLAY_NAME: 'Arqueo de Caja',
                TOOLTIP: '',
            },
        },
    },
    HOME: {
        TITLE: 'Inicio',
        ITEMS: {
        },
    },
}

const sidebarDictionary = {}
sidebarDictionary[Languages.ENGLISH_US] = DescriptionsEnUs
sidebarDictionary[Languages.SPANISH_US] = DescriptionsEsUs

export const getSidebarDescriptions = (systemLang: Languages): SidebarDescriptions => (
    sidebarDictionary[systemLang]
)
